import { mapWidgetConstants as constants } from "../_constants/map.widget.constants";

export const newMapWidget = (widget) => { return { type: constants.NEW_MAP_WIDGET, widget: widget }};
export const updateMapWidget = (widget) => { return { type: constants.UPDATE_MAP_WIDGET, widget: widget }};
export const deleteMapWidget = () => { return { type: constants.DELETE_MAP_WIDGET }};
